import { render } from "./DocumentThumbnail.vue?vue&type=template&id=48d371d2"
import script from "./DocumentThumbnail.vue?vue&type=script&lang=js"
export * from "./DocumentThumbnail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__